import styled, { css } from "styled-components";
import Header from "../../Header/Header";

export const DrawerHeader = styled(Header)(
    ({ theme }) => css`
        .Icon {
            color: ${theme.palette.gray[0]};
        }
    `,
);
